var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"keydown":function($event){$event.stopPropagation();}}},[_c('textarea',{ref:"redactor",attrs:{"id":_vm.name,"name":_vm.name,"placeholder":_vm.placeholder},domProps:{"value":_vm.value}})])
}
var staticRenderFns = []

export { render, staticRenderFns }